import templateUrl from 'emun.invoice/credit-memo.htm'
import controller from 'emun.invoice/credit-memo.controller'

export default {
    controller,
    bindings: {
        id: '@'
    },
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
};